import { type HTMLAttributes } from "react";
import clsx from "clsx";

export function Card({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        "bg-white rounded-xl border border-beige/20 shadow-sm",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
